import { render } from "./MatchdayTakeoverV2.vue?vue&type=template&id=59475596&scoped=true"
import script from "./MatchdayTakeoverV2.vue?vue&type=script&lang=js"
export * from "./MatchdayTakeoverV2.vue?vue&type=script&lang=js"

import "./MatchdayTakeoverV2.vue?vue&type=style&index=0&id=59475596&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59475596"]])

export default __exports__